import ListsList from './ListsList';

export default ListsList;
